var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sorting-arrow"},[_vm._t("default"),(_vm.value.dir && _vm.value.dir == 'asc')?_c('p',{on:{"click":_vm.dir}},[_c('icon',{attrs:{"icon":"arrow-up"}})],1):_c('p',{on:{"click":_vm.dir}},[_c('icon',{attrs:{"icon":"arrow-down"}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }